import { Injectable } from "@angular/core";
import { drctJsFunctions, DRCTMessage, DRCTWebAll } from "@drct-web-apps/ui-types";
import { UiServicesMessage } from "./ui-services.message.service";
import { Observable, ReplaySubject, Subscription, takeUntil } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { UiServicesUtils } from "./ui-services.utils.service";
import { UiServicesLogger } from "./ui-services.logger.service";
import { UiServiceWebSession } from "./ui-services.web-session.service";


@Injectable({
  providedIn: 'root'
})
export class UiServicesRecaptcha {
  private destroyed$!: ReplaySubject<boolean>;
  private readonly _recaptchaKey = '6Ldzhs8pAAAAAFmm8Nk0V7ff-IgBlBwk9hCEeb30';
  private tokenSubscription!: Subscription;

  constructor(private readonly msgBus: UiServicesMessage, private readonly http: HttpClient,
              private readonly utils: UiServicesUtils, private readonly logger: UiServicesLogger,
              private readonly session: UiServiceWebSession) { }

  public removeSubscriptions(): void {
    if(this.tokenSubscription)
        this.tokenSubscription.unsubscribe();
    
    if(this.destroyed$) {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
  }

  private getGoogleReCaptchaToken(): void {
      drctJsFunctions.getRecaptchaToken(this._recaptchaKey);
  }

  public validateGoogleReCaptcha(): Observable<DRCTWebAll> {
    this.destroyed$ = new ReplaySubject(1);
    const tokenPromise = new Promise<DRCTMessage>((resolve, reject) => {
                          this.getGoogleReCaptchaToken();
                          this.logger.log('Waiting for CAPTCHA token...');

                          this.tokenSubscription = 
                          this.msgBus.onMessage("CAPTCHA")
                                     .subscribe({
                                        next:(msg: DRCTMessage) => {
                                            if(msg.subType === 'CAPTCHA_TOKEN')
                                                resolve(msg);
                                            else
                                                reject("Captcha Token Not Received.");
                                        },
                                        error: (err) => {
                                            reject(err);
                                        }
                                      });
      
                        });

    const tokenValidator = new ReplaySubject<DRCTWebAll>(1);
    tokenPromise.then((msg: DRCTMessage) => {
      this.logger.log('reCAPTCHA token Received. Validating token...');
     
      const uuid = this.session.webConfig?.uuid ?? '';
      const captchaForm = new FormData();
      captchaForm.append('data', JSON.stringify({ 'token': msg.message, 'uuid': uuid}));

      this.http.post(this.utils.builApiUrlWithEnv("drct_recaptcha.php"), captchaForm)
               .pipe(takeUntil(this.destroyed$))
               .subscribe({
                    next: (response: DRCTWebAll) => {
                      tokenValidator.next(response);
                    },
                    error: (err) => {
                      tokenValidator.error(err);
                    },
                    complete: () => {
                      tokenValidator.complete();
                    }
                });
    }).catch((err) => {
      tokenValidator.error(err);
    });

    return tokenValidator.asObservable();
  }
}